module.exports = __webpack_public_path__ + "img/ring_0_0_0_null@3x.9b9a4671.png";